import Vue from 'vue';
// import {resolveFeatureForComponent} from "@/appManager/featureResolver";

const installedPlugins = new Set();
const registeredComponents = new Set();
const registeredFilters = new Set();

export function registerComponent(name, importer) {

    Vue.component(name, async () => {

        // 1. ensure feature is loaded (side-effect safe)
        // await resolveFeatureForComponent(name);

        // 2. load component
        const comp = typeof importer === 'function'
            ? await importer()
            : importer;

        return comp.default || comp;
    });
}

export function registerDirective(name, def) {
    Vue.directive(name, def);
}

export function registerFilter(name, fn) {
    if (registeredFilters.has(name)) return;

    Vue.filter(name, fn);
    registeredFilters.add(name);
}

export function registerPlugin(plugin, options) {
    if (installedPlugins.has(plugin)) return;

    Vue.use(plugin, options);
    installedPlugins.add(plugin);
}
